import React, {useEffect, useState, useMemo} from "react";
import {useDispatch, useSelector} from "react-redux";
import {relationshipTypeAction} from "redux/actions";


export default function AddRelationshipType(status) {

    const [relationshipname, setRelationshipname] = useState('');
    const [description, setDescription] = useState('');


    const {customers, userRole} = useSelector(state => ({
        customers: state.customers,
        userRole: state.userRole?.filter(role => role.module === "Customers")
    }));

    const dispatch = useDispatch();
    useEffect(() => {
        
    }, []);

    const addData = () =>{
        dispatch(relationshipTypeAction.add({ name: relationshipname, desc: description}));
        setRelationshipname('');
        setDescription('');
    } 

   
    return (
        <div>
            <h2>Add Relationship Types</h2>
            <form action="/action_page.php">
                <div className="form-group" style={{marginBottom:"15px"}}>
                    <label for="relationship_name">Relationship Name:</label>
                    <input type="text" className="form-control" id="relationship_name" placeholder="Enter Relationship Name" name="relationship_name" onChange={e => setRelationshipname(e.target.value)} value={relationshipname}/>
                </div>
                <div className="form-group" style={{marginBottom:"15px"}}>
                    <label for="description">Relationship Description:</label>
                    <input type="text" className="form-control" id="description" placeholder="Enter Relationship Description" name="description" onChange={e => setDescription(e.target.value)} value={description} />
                </div>
                <div className="form-group" style={{marginBottom:"15px",textAlign:"right"}}>
                    <button type="button" className="btn btn-primary" onClick={addData}>Submit</button>
                </div>
            </form>
        </div>
    );
}
